import groups from '@/modules/fleet-module/groups/routes/index.child'
import group from '@/modules/fleet-module/groups/routes/show.child'
import vehicle from '@/modules/fleet-module/vehicles/routes/show.child'
import vehicleTags from '@/modules/fleet-module/vehicle-tags/routes/index.child'
import vehicleTag from '@/modules/fleet-module/vehicle-tags/routes/show.child'
import vehicles from '@/modules/fleet-module/vehicles/routes/index.child'
import department from '@/modules/fleet-module/department/routes/index.child'
import organizationalUnit from '@/modules/fleet-module/organizational-unit/routes/index.child'
import vehicleReservationOverview from '@/modules/fleet-module/vehicles-reservations/routes/index.child'
import vehicleReservationHistory from '@/modules/fleet-module/vehicles-reservations-history/routes/index.child'

export default {
  path: '/fleet',
  redirect: {
    name: 'NotFound',
    params: {
      pathMatch: '/fleet'
    }
  },
  component: () => import(/* webpackChunkName: "fleet" */ '../views/FleetView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  },
  children: [
    groups,
    group,
    vehicle,
    vehicleTags,
    vehicleTag,
    vehicles,
    department,
    organizationalUnit,
    vehicleReservationOverview,
    vehicleReservationHistory
  ]
}
